<div
  class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0"
  *ngIf="editRow"
  (click)="onCancel()"
>
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div
    class="relative bg-white rounded-2xl shadow-xl p-4 md:p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto transition-all duration-150"
    (click)="$event.stopPropagation()"
  >
    <!-- Cabeçalho -->
    <div class="flex items-center justify-between gap-2 mb-4">
      <span class="text-sm font-bold text-chathams-blue">
        {{ isCreating ? 'Adicionar produto' : 'Editar produto' }}
      </span>
      <button type="button" class="btn btn--secondary px-3 h-8" (click)="onCancel()">Fechar</button>
    </div>

    <!-- Abas -->
    <div class="flex gap-1 mb-5 border-b border-gray-200">
      <button
        type="button"
        class="px-4 py-2 text-xs font-bold uppercase transition-colors"
        [class.text-chathams-blue]="activeTab === 'produto'"
        [class.border-b-2]="activeTab === 'produto'"
        [class.border-chathams-blue]="activeTab === 'produto'"
        [class.text-gray-400]="activeTab !== 'produto'"
        (click)="activeTab = 'produto'"
      >
        Produto
      </button>
      <button
        type="button"
        class="px-4 py-2 text-xs font-bold uppercase transition-colors"
        [class.text-chathams-blue]="activeTab === 'condicoes'"
        [class.border-b-2]="activeTab === 'condicoes'"
        [class.border-chathams-blue]="activeTab === 'condicoes'"
        [class.text-gray-400]="activeTab !== 'condicoes'"
        (click)="activeTab = 'condicoes'"
      >
        Condições
      </button>
      <button
        type="button"
        class="px-4 py-2 text-xs font-bold uppercase transition-colors"
        [class.text-chathams-blue]="activeTab === 'perguntas'"
        [class.border-b-2]="activeTab === 'perguntas'"
        [class.border-chathams-blue]="activeTab === 'perguntas'"
        [class.text-gray-400]="activeTab !== 'perguntas'"
        (click)="activeTab = 'perguntas'"
      >
        Perguntas
      </button>
    </div>

    <!-- Aba: Produto -->
    <div *ngIf="activeTab === 'produto'" class="flex flex-col gap-3">
      <div class="flex items-center gap-3" [class.hidden]="!editRow.productPhotoLink">
        <img
          #previewImg
          class="w-16 h-16 object-cover rounded"
          [src]="editRow.productPhotoLink || ''"
          [alt]="editRow.productName || 'Produto'"
          (error)="previewImg.hidden = true"
          (load)="previewImg.hidden = false"
        />
        <small class="text-xs text-chathams-blue">Pré-visualização</small>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2">Item</label>
          <input
            class="form-input"
            placeholder="SKU / Item"
            [(ngModel)]="editRow.itemNumber"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2">Marca</label>
          <input
            class="form-input"
            placeholder="Nome da marca"
            [(ngModel)]="editRow.brandName"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2">Nome do produto</label>
          <input
            class="form-input"
            placeholder="Nome do produto"
            [(ngModel)]="editRow.productName"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2">Categorias</label>
          <ng-select
            [searchable]="false"
            notFoundText="Nenhum item encontrado"
            placeholder="Selecione uma categoria"
            [(ngModel)]="editRow.categories"
            [ngModelOptions]="{ standalone: true }"
          >
            <ng-option *ngFor="let opt of categoryOptions" [value]="opt">{{ opt }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2">Rotina</label>
          <ng-select
            [searchable]="false"
            notFoundText="Nenhum item encontrado"
            placeholder="Selecione a rotina"
            [(ngModel)]="editRow.routineInformation"
            [ngModelOptions]="{ standalone: true }"
          >
            <ng-option *ngFor="let opt of routineOptions" [value]="opt">{{ opt }}</ng-option>
          </ng-select>
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2">Foto (URL)</label>
          <input
            class="form-input"
            placeholder="https://..."
            [(ngModel)]="editRow.productPhotoLink"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2">Link do produto</label>
          <input
            class="form-input"
            placeholder="https://..."
            [(ngModel)]="editRow.productLink"
            [ngModelOptions]="{ standalone: true }"
          />
        </div>
        <div class="form-group">
          <label class="block text-gray-700 text-sm font-bold mb-2">Preço (opcional)</label>
          <input
            class="form-input"
            inputmode="decimal"
            placeholder="R$ 89,90"
            [(ngModel)]="editRow.price"
            [ngModelOptions]="{ standalone: true }"
          />
          <small class="text-xs text-cerise-red-600" *ngIf="!isPriceValid(editRow.price)">
            Informe um valor como 89,90. Vazio = sem preço.
          </small>
        </div>
        <div class="form-group md:col-span-2">
          <label class="block text-gray-700 text-sm font-bold mb-2">Descrição</label>
          <textarea
            class="form-input"
            rows="6"
            placeholder="Descrição do produto"
            [(ngModel)]="editRow.productDescription"
            [ngModelOptions]="{ standalone: true }"
          ></textarea>
        </div>
        <div class="form-group md:col-span-2">
          <div class="flex items-center justify-between mb-2">
            <label class="block text-gray-700 text-sm font-bold">Peso (opcional)</label>
            <button
              *ngIf="editRow.weight"
              type="button"
              class="text-xs text-chathams-blue underline"
              (click)="clearWeight()"
            >
              Limpar
            </button>
          </div>
          <input
            type="range"
            class="w-full"
            [min]="minWeight"
            [max]="maxWeight"
            step="0.1"
            [value]="getWeightRangeValue(editRow.weight)"
            (input)="onWeightRangeInput($event)"
          />
          <div class="flex justify-between mt-1">
            <small class="text-xs text-chathams-blue">Arraste para definir o peso</small>
            <span class="text-xs font-bold text-chathams-blue">{{ getWeightLabel(editRow.weight) }}</span>
          </div>
          <small class="text-xs text-cerise-red-600" *ngIf="!isWeightValid(editRow.weight)">
            Informe um número entre {{ minWeight }} e {{ maxWeight }}.
          </small>
        </div>
      </div>
    </div>

    <!-- Aba: Condições -->
    <div *ngIf="activeTab === 'condicoes'" class="flex flex-col gap-4">
      <small class="text-xs text-chathams-blue">
        Defina a faixa de severidade para cada condição. Deixe em 0–0 para não indicar tratamento.
      </small>
      <div *ngFor="let c of conditions" class="form-group">
        <div class="flex items-center justify-between mb-1">
          <label class="block text-gray-700 text-sm font-bold">{{ c.label }}</label>
          <div class="flex items-center gap-2">
            <span class="text-xs font-bold text-chathams-blue min-w-16 text-right">
              {{ conditionSliders[c.key][0] }}–{{ conditionSliders[c.key][1] }}
            </span>
            <button
              *ngIf="conditionSliders[c.key][0] > 0 || conditionSliders[c.key][1] > 0"
              type="button"
              class="text-xs text-chathams-blue underline"
              (click)="clearCondition(c.key)"
            >
              Limpar
            </button>
          </div>
        </div>
        <div class="flex flex-col gap-1">
          <div class="flex items-center gap-2">
            <span class="text-xs text-gray-400 w-6">Mín</span>
            <input
              type="range"
              class="w-full"
              min="0"
              max="100"
              step="1"
              [value]="conditionSliders[c.key][0]"
              (input)="onMinSlider(c.key, $event)"
            />
            <span class="text-xs font-bold text-chathams-blue w-8 text-right">
              {{ conditionSliders[c.key][0] }}
            </span>
          </div>
          <div class="flex items-center gap-2">
            <span class="text-xs text-gray-400 w-6">Máx</span>
            <input
              type="range"
              class="w-full"
              min="0"
              max="100"
              step="1"
              [value]="conditionSliders[c.key][1]"
              (input)="onMaxSlider(c.key, $event)"
            />
            <span class="text-xs font-bold text-chathams-blue w-8 text-right">
              {{ conditionSliders[c.key][1] }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Aba: Perguntas -->
    <div *ngIf="activeTab === 'perguntas'" class="flex flex-col gap-3">
      <small class="text-xs text-chathams-blue" *ngIf="!questions.length">
        Selecione uma empresa e carregue as perguntas do skincare antes de editar respostas.
      </small>
      <div *ngFor="let q of questions; let i = index" class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2"> Pergunta {{ i + 1 }}: {{ q.text }} </label>
        <ng-select
          [searchable]="true"
          [multiple]="true"
          notFoundText="Nenhum item encontrado"
          placeholder="Selecione uma ou mais opções"
          [ngModel]="editRow.answersByQuestionId[q.id.toString()] || []"
          (ngModelChange)="editRow.answersByQuestionId[q.id.toString()] = $event"
          [ngModelOptions]="{ standalone: true }"
        >
          <ng-option *ngFor="let opt of getQuestionOptionTexts(q)" [value]="opt">
            {{ opt }}
          </ng-option>
        </ng-select>
      </div>
    </div>

    <!-- Rodapé -->
    <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-gray-100">
      <button type="button" class="h-9 px-4 btn btn--secondary" (click)="onCancel()">Cancelar</button>
      <button type="button" class="h-9 px-4 btn btn--primary" (click)="onSave()">
        {{ isCreating ? 'Adicionar' : 'Salvar' }}
      </button>
    </div>
  </div>
</div>
